import {Radar, Dot, RadarChart, PolarGrid, Legend, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer} from "recharts";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import {ExportToExcel} from "../ExportToExcel.jsx";
import {CopyDataToClipboard} from "../CopyDataToClipboard.jsx";
import {useSelector} from "react-redux";
import TooltipInfo from "../TooltipInfo.jsx";

export const RadarChartAnaliza = ({
                                    data,
                                    dataKeys,
                                    title,
                                    selectors,
                                    hideExelExport = false,
                                    hideCopyToclipboard = false,
                                    tooltipKey,

                                  }) => {

    // const getRandomColor = () =>
    //     "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
    //
    // const dataKeys = useMemo(() => {
    //     if (!data.length) return [];
    //     const keys = new Set();
    //     data.forEach((item) => {
    //         Object.keys(item).forEach((key) => {
    //             if (key !== "slownik_typ_zadania_nazwa") {
    //                 keys.add(key);
    //             }
    //         });
    //     });
    //     return Array.from(keys);
    // }, [data]);
    //
    // const colors = useMemo(() => {
    //     const colorMap = {};
    //     dataKeys.forEach((key) => {
    //         colorMap[key] = getRandomColor();
    //     });
    //     return colorMap;
    // }, [dataKeys]);

    //const showDots = data.length === 1;

    const tooltipHtml = useSelector(state =>
        state.chartTooltips.msg[tooltipKey]?.value
    );

    return (
        <Card>
            <Card.Header>
                <div className={'d-flex justify-content-between gap-3'}>
                    <div className={'d-flex justify-content-between'}>
                        <div className={'fs-5'}>
                            {title ?? 'Analiza'}
                        </div>
                        <div>
                            {tooltipHtml && (
                                <TooltipInfo text={tooltipHtml} className="ms-2" />
                            )}
                        </div>
                    </div>
                    <div>
                        {!!selectors && selectors()}
                    </div>
                    <div>
                        {(!hideExelExport && data) &&
                            <ExportToExcel
                                data={data}
                                fileName={title || 'analiza'}
                            />
                        }
                        {(!hideCopyToclipboard && data) &&
                            <CopyDataToClipboard data={data}/>
                        }
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <ResponsiveContainer width="100%" height={900}>
                    <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
                        <PolarGrid/>
                        <PolarAngleAxis dataKey="slownik_typ_zadania_nazwa"/>
                        <PolarRadiusAxis angle={30} domain={[0, 5]}/>
                        {/*<Radar name="Mike" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />*/}
                        {
                            // dataKeys.map((dataKey, idx) => (
                            //     <Radar key={idx} name={dataKey} dataKey={dataKey} stroke={colors[dataKey]}
                            //            fill={colors[dataKey]} fillOpacity={0.1}/>
                            // ))

                            dataKeys.map((dataKey, idx) => (
                                <Radar
                                    key={idx}
                                    name={dataKey.dataKey}
                                    dataKey={dataKey.dataKey}
                                    stroke={dataKey.color}
                                    fill={dataKey.color}
                                    fillOpacity={0.1}
                                    dot={ (props) => {
                                        if (!dataKey.showDot || props.value <= 0) {
                                            return null
                                        }
                                        return <Dot {...props} />;
                                    }}
                                />
                            ))
                        }
                        <Legend/>
                    </RadarChart>
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    )
}

RadarChartAnaliza.propTypes = {
    data: PropTypes.array.isRequired,
    dataKeys: PropTypes.arrayOf(
        PropTypes.shape({
            dataKey: PropTypes.string.isRequired,
            color: PropTypes.string.isRequired
        })
    ).isRequired,
    fill: PropTypes.string,
    title: PropTypes.string,
    colors: PropTypes.array,
    selectors: PropTypes.func,
    hideExelExport: PropTypes.bool,
    hideCopyToclipboard: PropTypes.bool,
    tooltipKey: PropTypes.string,
}
